"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shoppingCart = exports.clearPaymentDetails = exports.getPaymentDetails = exports.setPaymentDetails = exports.getShoppingCartValues = exports.setCognitoValue = exports.setCognitoVehicleValue = exports.setCognitoValues = exports.ensureVisitorProfile = exports.ensureLegacyCustomerPortalProfile = exports.ensureAuto5Profile = exports.getCognitoValue = exports.fetchData = exports.refresh = exports.start = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var queries = __importStar(require("./graphql/queries"));
var mutations = __importStar(require("./graphql/mutations"));
var api_1 = __importStar(require("@aws-amplify/api"));
var API_1 = require("./API");
var vid_1 = require("./vid");
var debug_1 = __importDefault(require("debug"));
var debug = debug_1.default('jazel:customer-portal:cognit-shopping-cart');
var vinsKeysMap = {
    'recent_vins': 'recentVehicles',
    'favorite_vins': 'favoriteVehicles',
    'compare_vins': 'compareVehicles',
};
var vinsKeyToEnumMap = {
    'recent_vins': API_1.SavedVehicleType.Recent,
    'favorite_vins': API_1.SavedVehicleType.Favorite,
    'compare_vins': API_1.SavedVehicleType.Compare,
};
var currentData;
function start() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refresh()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.start = start;
function refresh() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchData(vid_1.getVid())];
                case 1:
                    currentData = _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.refresh = refresh;
function fetchData(vid) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        vid: vid,
                        auto5: {},
                        legacyCustomerPortal: {},
                    };
                    return [4 /*yield*/, fetchAuto5Profile(data)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchLegacyCustomerPortalProfile(data)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
exports.fetchData = fetchData;
function getCognitoValue(key) {
    if (key === void 0) { key = ''; }
    // name may be postfixed
    var segments = key.split(';');
    var name = segments[0], option = segments[1];
    debug('getCognitoValue', name);
    if (name in vinsKeysMap) {
        var vehicles = currentData.auto5[vinsKeysMap[name]];
        if (vehicles == null) {
            vehicles = [];
        }
        if (option === 'obj') {
            return Promise.resolve(vehicles);
        }
        else {
            var vins = vehicles.map(function (vehicle) { return vehicle.vin; });
            var vinsAsString = vins.join(',');
            return Promise.resolve(vinsAsString);
        }
    }
    return Promise.resolve(true);
}
exports.getCognitoValue = getCognitoValue;
function setCognitoAuto5Values(objectWithValues, submit) {
    return __awaiter(this, void 0, void 0, function () {
        var updateVehicles, _i, _a, _b, key, value, input_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    updateVehicles = false;
                    for (_i = 0, _a = Object.entries(vinsKeysMap); _i < _a.length; _i++) {
                        _b = _a[_i], key = _b[0], value = _b[1];
                        if (key in objectWithValues) {
                            updateVehicles = true;
                            currentData.auto5[value] = objectWithValues[key].split(',')
                                .map(function (vin) { return ({
                                vin: vin,
                            }); });
                        }
                    }
                    if (!updateVehicles) return [3 /*break*/, 2];
                    if (!submit) return [3 /*break*/, 2];
                    input_1 = {
                        id: currentData.vid,
                    };
                    Object.entries(vinsKeysMap).forEach(function (kv) {
                        var key = kv[0];
                        var value = kv[1];
                        if (key in objectWithValues) {
                            debug('key', key);
                            var currentDataForKey_1 = {};
                            if (currentData.auto5[value] != null) {
                                for (var _i = 0, _a = currentData.auto5[value]; _i < _a.length; _i++) {
                                    var obj = _a[_i];
                                    currentDataForKey_1[obj.vin] = obj;
                                }
                            }
                            input_1[value] = objectWithValues[key].split(',')
                                .map(function (vin) {
                                var newEntry = Object.assign({}, currentDataForKey_1[vin], { vin: vin });
                                if (newEntry.lastKnownPrice == null) {
                                    // TODO
                                }
                                if (newEntry.updatedAt == null) {
                                    newEntry.updatedAt = Math.floor(Date.now() / 1000);
                                }
                                return newEntry;
                            });
                        }
                    });
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.updateAuto5Profile, { input: input_1 }))];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
var legacyCustomerPortalProfileKeysMap = {
    'visitor_info': 'visitorInfo',
    "vehicle_of_interest": 'vehicleOfInterest',
    "estimate_payments": 'estimatePayments',
    'apply_for_financing': 'applyForFinancing',
    "schedule_test_drive": 'scheduleTestDrive',
    "trade_in_value": 'tradeInValue',
    "active_ui": { json: false, field: 'activeUi' },
};
function setCognitoLegacyCustomerPortalData(objectWithValues, submit) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var updated, objectToMerge, _i, _b, _c, key, value, def, fieldValue, input;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    updated = false;
                    objectToMerge = {};
                    for (_i = 0, _b = Object.entries(legacyCustomerPortalProfileKeysMap); _i < _b.length; _i++) {
                        _c = _b[_i], key = _c[0], value = _c[1];
                        if (key in objectWithValues) {
                            updated = true;
                            def = typeof value === 'string' ? { json: true, field: value } : value;
                            fieldValue = objectWithValues[key];
                            if (def.json) {
                                try {
                                    fieldValue = JSON.parse(fieldValue);
                                }
                                catch (ex) {
                                    fieldValue = {};
                                }
                            }
                            objectToMerge[def.field] = fieldValue;
                        }
                    }
                    if (!updated) return [3 /*break*/, 4];
                    currentData.legacyCustomerPortal.data = deepmerge_1.default((_a = currentData.legacyCustomerPortal.data) !== null && _a !== void 0 ? _a : {}, objectToMerge);
                    if (!submit) return [3 /*break*/, 4];
                    return [4 /*yield*/, ensureVisitorProfile(currentData.vid)];
                case 1:
                    _d.sent();
                    return [4 /*yield*/, ensureLegacyCustomerPortalProfile(currentData.vid)];
                case 2:
                    _d.sent();
                    input = {
                        id: currentData.vid,
                    };
                    input.dataJson = JSON.stringify(currentData.legacyCustomerPortal.data);
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.updateLegacyCustomerPortalProfile, { input: input }))];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function ensureAuto5Profile(vid) {
    return __awaiter(this, void 0, void 0, function () {
        var auto5Profile, result, result_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    auto5Profile = null;
                    console.log("Checking for Auto5Profile", vid);
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(queries.getAuto5Profile, { id: vid }))];
                case 1:
                    result = _a.sent();
                    if (result != null) {
                        auto5Profile = result.data.getAuto5Profile;
                    }
                    else {
                        throw new Error("Could not run getAuto5Profile");
                    }
                    if (!(auto5Profile == null)) return [3 /*break*/, 3];
                    console.log("Auto5Profile did not exist, creating...", vid);
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.createAuto5Profile, { input: { id: vid } }))];
                case 2:
                    result_1 = _a.sent();
                    if (result_1 != null) {
                        console.log("Auto5Profile created", vid, result_1);
                        auto5Profile = result_1.data.createAuto5Profile;
                    }
                    else {
                        throw new Error("Could not run createAuto5Profile");
                    }
                    if (auto5Profile.id !== vid) {
                        throw new Error("Created Auto5Profile has unexpected id: " + auto5Profile.id);
                    }
                    _a.label = 3;
                case 3:
                    console.log("Returning Auto5Profile", vid);
                    return [2 /*return*/, auto5Profile];
            }
        });
    });
}
exports.ensureAuto5Profile = ensureAuto5Profile;
function ensureLegacyCustomerPortalProfile(vid) {
    return __awaiter(this, void 0, void 0, function () {
        var legacyCustomerPortalProfile, result, result_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    legacyCustomerPortalProfile = null;
                    console.log("Checking for CustomerPortalProfile", vid);
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(queries.getLegacyCustomerPortalProfile, { id: vid }))];
                case 1:
                    result = _a.sent();
                    if (result != null) {
                        legacyCustomerPortalProfile = result.data.getLegacyCustomerPortalProfile;
                    }
                    else {
                        throw new Error("Could not run getLegacyCustomerPortalProfile");
                    }
                    if (!(legacyCustomerPortalProfile == null)) return [3 /*break*/, 3];
                    console.log("CustomerPortalProfile did not exist, creating...", vid);
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.createLegacyCustomerPortalProfile, { input: { id: vid } }))];
                case 2:
                    result_2 = _a.sent();
                    if (result_2 != null) {
                        console.log("CustomerPortalProfile created", vid, result_2);
                        legacyCustomerPortalProfile = result_2.data.createLegacyCustomerPortalProfile;
                    }
                    else {
                        throw new Error("Could not run createLegacyCustomerPortalProfile");
                    }
                    if (legacyCustomerPortalProfile.id !== vid) {
                        throw new Error("Created CustomerPortalProfile has unexpected id: " + legacyCustomerPortalProfile.id);
                    }
                    _a.label = 3;
                case 3:
                    console.log("Returning CustomerPortalProfile", vid);
                    return [2 /*return*/, legacyCustomerPortalProfile];
            }
        });
    });
}
exports.ensureLegacyCustomerPortalProfile = ensureLegacyCustomerPortalProfile;
function ensureVisitorProfile(vid) {
    return __awaiter(this, void 0, void 0, function () {
        var visitorProfile, result, result_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    visitorProfile = null;
                    console.log("Checking for VisitorProfile", vid);
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(queries.visitorProfile, { id: vid }))];
                case 1:
                    result = _a.sent();
                    if (result != null) {
                        visitorProfile = result.data.visitorProfile;
                    }
                    else {
                        throw new Error("Could not run getVisitorProfile");
                    }
                    if (!(visitorProfile == null)) return [3 /*break*/, 3];
                    console.log("VisitorProfile did not exist, creating...", vid);
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.createVisitorProfile, { input: { id: vid } }))];
                case 2:
                    result_3 = _a.sent();
                    if (result_3 != null) {
                        console.log("VisitorProfile created", vid, result_3);
                        visitorProfile = result_3.data.createVisitorProfile;
                    }
                    else {
                        throw new Error("Could not run createVisitorProfile");
                    }
                    if (visitorProfile.id !== vid) {
                        throw new Error("Created VisitorProfile has unexpected id: " + visitorProfile.id);
                    }
                    _a.label = 3;
                case 3:
                    console.log("Returning VisitorProfile", vid);
                    return [2 /*return*/, visitorProfile];
            }
        });
    });
}
exports.ensureVisitorProfile = ensureVisitorProfile;
function setCognitoValues(objectWithValues, submit) {
    if (submit === void 0) { submit = true; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // If objectWithValues contains favorite_vins, recent_vins, or compare_vins, then do this:
                return [4 /*yield*/, setCognitoAuto5Values(objectWithValues, submit)];
                case 1:
                    // If objectWithValues contains favorite_vins, recent_vins, or compare_vins, then do this:
                    _a.sent();
                    // Other fields
                    return [4 /*yield*/, setCognitoLegacyCustomerPortalData(objectWithValues, submit)];
                case 2:
                    // Other fields
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.setCognitoValues = setCognitoValues;
function setCognitoVehicleValue(key, inputValues) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var segments, name, option, mappedName, vin, value, input, dataKey, result, dataKey, doNothing, currentItem, input, result, input, result, saveAuto5Vehicle;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    segments = key.split(';');
                    name = segments[0], option = segments[1];
                    mappedName = vinsKeyToEnumMap[name];
                    if (mappedName == null) {
                        return [2 /*return*/];
                    }
                    vin = inputValues.vin, value = inputValues.value;
                    if (!(vin === '*')) return [3 /*break*/, 3];
                    if (!!value) return [3 /*break*/, 2];
                    input = {
                        vid: currentData.vid,
                        type: mappedName,
                    };
                    dataKey = vinsKeysMap[name];
                    currentData.auto5[dataKey] = [];
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.clearAuto5VehicleList, input))];
                case 1:
                    result = _b.sent();
                    debug("save result", result);
                    return [2 /*return*/, result.data.clearAuto5VehicleList];
                case 2: 
                // This is not allowed
                throw new Error("setCognitoVehicleValue: vin=* only allowed when set=false.");
                case 3:
                    dataKey = vinsKeysMap[name];
                    currentData.auto5[dataKey] = (_a = currentData.auto5[dataKey]) !== null && _a !== void 0 ? _a : [];
                    doNothing = false;
                    if (option === 'update_price') {
                        currentItem = currentData.auto5[dataKey].find(function (x) { return x.vin === vin; });
                        if (currentItem == null) {
                            doNothing = true;
                        }
                    }
                    if (!doNothing) return [3 /*break*/, 5];
                    input = {
                        id: currentData.vid,
                    };
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(queries.getAuto5Profile, input))];
                case 4:
                    result = _b.sent();
                    return [2 /*return*/, result.data.getAuto5Profile];
                case 5:
                    input = {
                        vid: currentData.vid,
                        vin: vin,
                        set: value,
                        type: mappedName,
                    };
                    if (inputValues.price != null) {
                        input.price = inputValues.price;
                    }
                    currentData.auto5[dataKey] = currentData.auto5[dataKey].filter(function (x) { return x.vin !== vin; });
                    if (inputValues.value) {
                        currentData.auto5[dataKey].push({ vin: vin, lastKnownPrice: inputValues.price, });
                    }
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.saveAuto5Vehicle, input))];
                case 6:
                    result = _b.sent();
                    saveAuto5Vehicle = result.data.saveAuto5Vehicle;
                    if (saveAuto5Vehicle[dataKey] != null) {
                        currentData.auto5[dataKey] = saveAuto5Vehicle[dataKey];
                    }
                    return [2 /*return*/, result.data.saveAuto5Vehicle];
            }
        });
    });
}
exports.setCognitoVehicleValue = setCognitoVehicleValue;
function setCognitoValue(name, value) {
    return __awaiter(this, void 0, void 0, function () {
        var values;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    values = {};
                    values[name] = value;
                    return [4 /*yield*/, setCognitoValues(values)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.setCognitoValue = setCognitoValue;
function fetchAuto5Profile(currentData) {
    return __awaiter(this, void 0, void 0, function () {
        var input, result, auto5Profile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    input = {
                        id: currentData.vid,
                    };
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(queries.getAuto5Profile, input))];
                case 1:
                    result = _a.sent();
                    auto5Profile = result.data.getAuto5Profile;
                    Object.values(vinsKeysMap).forEach(function (value) {
                        var vinsValue = auto5Profile === null || auto5Profile === void 0 ? void 0 : auto5Profile[value];
                        if (vinsValue == null) {
                            vinsValue = [];
                        }
                        currentData.auto5[value] = vinsValue;
                    });
                    currentData.auto5.paymentDetails = auto5Profile === null || auto5Profile === void 0 ? void 0 : auto5Profile.paymentDetails;
                    return [2 /*return*/];
            }
        });
    });
}
function fetchLegacyCustomerPortalProfile(currentData) {
    return __awaiter(this, void 0, void 0, function () {
        var input, result, legacyCustomerPortalProfile, data, _i, _a, value, def, fieldValue;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    input = {
                        id: currentData.vid,
                    };
                    currentData.legacyCustomerPortal.data = {};
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(queries.getLegacyCustomerPortalProfile, input))];
                case 1:
                    result = _b.sent();
                    legacyCustomerPortalProfile = result.data.getLegacyCustomerPortalProfile;
                    try {
                        data = JSON.parse(legacyCustomerPortalProfile.dataJson);
                    }
                    catch (ex) {
                        data = {};
                    }
                    for (_i = 0, _a = Object.values(legacyCustomerPortalProfileKeysMap); _i < _a.length; _i++) {
                        value = _a[_i];
                        def = typeof value === 'string' ? { json: true, field: value } : value;
                        fieldValue = data[def.field];
                        if (fieldValue != null) {
                            currentData.legacyCustomerPortal.data[def.field] = fieldValue;
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getShoppingCartValues(data) {
    return __awaiter(this, void 0, void 0, function () {
        var shoppingCartValues, theData, _i, _a, _b, key, value, def, fieldValue;
        return __generator(this, function (_c) {
            shoppingCartValues = {};
            theData = data !== null && data !== void 0 ? data : currentData;
            shoppingCartValues['vid'] = theData.vid;
            Object.entries(vinsKeysMap).forEach(function (kv) {
                var key = kv[0];
                var value = kv[1];
                var auto5Value = theData.auto5[value];
                if (auto5Value == null) {
                    auto5Value = [];
                }
                shoppingCartValues[key] = auto5Value.map(function (vehicle) { return vehicle.vin; }).join(',');
            });
            if (theData.legacyCustomerPortal.data != null) {
                for (_i = 0, _a = Object.entries(legacyCustomerPortalProfileKeysMap); _i < _a.length; _i++) {
                    _b = _a[_i], key = _b[0], value = _b[1];
                    def = typeof value === 'string' ? { json: true, field: value } : value;
                    fieldValue = theData.legacyCustomerPortal.data[def.field];
                    if (fieldValue != null) {
                        if (def.json) {
                            fieldValue = JSON.stringify(fieldValue);
                        }
                        shoppingCartValues[key] = fieldValue;
                    }
                }
            }
            return [2 /*return*/, shoppingCartValues];
        });
    });
}
exports.getShoppingCartValues = getShoppingCartValues;
function setPaymentDetails(aprTier, apr, term, downPayment) {
    return __awaiter(this, void 0, void 0, function () {
        var input, result, saveAuto5PaymentDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    input = {
                        vid: currentData.vid,
                        aprTier: aprTier,
                        apr: apr,
                        term: term,
                        downPayment: downPayment,
                    };
                    currentData.auto5.paymentDetails = input;
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.saveAuto5PaymentDetails, input))];
                case 1:
                    result = _a.sent();
                    saveAuto5PaymentDetails = result.data.saveAuto5PaymentDetails;
                    if (saveAuto5PaymentDetails != null) {
                        currentData.auto5.paymentDetails = saveAuto5PaymentDetails.paymentDetails;
                    }
                    return [2 /*return*/, result.data.saveAuto5PaymentDetails];
            }
        });
    });
}
exports.setPaymentDetails = setPaymentDetails;
function getPaymentDetails() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve(currentData.auto5.paymentDetails)];
        });
    });
}
exports.getPaymentDetails = getPaymentDetails;
function clearPaymentDetails() {
    return __awaiter(this, void 0, void 0, function () {
        var input, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    input = {
                        vid: currentData.vid,
                    };
                    currentData.auto5.paymentDetails = null;
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.clearAuto5PaymentDetails, input))];
                case 1:
                    result = _a.sent();
                    debug("save result", result);
                    return [2 /*return*/, result.data.clearAuto5PaymentDetails];
            }
        });
    });
}
exports.clearPaymentDetails = clearPaymentDetails;
exports.shoppingCart = {
    name: "cognitoShoppingCart",
    getShoppingCartValue: getCognitoValue,
    setShoppingCartValue: setCognitoValue,
    setShoppingVehicleValue: setCognitoVehicleValue,
    setShoppingCartValues: setCognitoValues,
    setPaymentDetails: setPaymentDetails,
    getPaymentDetails: getPaymentDetails,
    clearPaymentDetails: clearPaymentDetails,
};
//# sourceMappingURL=cognito.js.map